import { render, staticRenderFns } from "./AddNewLocation.vue?vue&type=template&id=36a2296a&scoped=true&"
import script from "./AddNewLocation.vue?vue&type=script&lang=js&"
export * from "./AddNewLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2296a",
  null
  
)

export default component.exports